import { BUSINESS_HOURS_DAY_ENABLED_CHANGE } from '../types'

export default function doBusinessHoursDayEnabledChange(dayNumber) {
  return {
    type: BUSINESS_HOURS_DAY_ENABLED_CHANGE,
    payload: {
      dayNumber,
    },
  }
}
